import { render, staticRenderFns } from "./addQuestionModal.vue?vue&type=template&id=01f06c29&scoped=true"
import script from "./addQuestionModal.vue?vue&type=script&lang=ts"
export * from "./addQuestionModal.vue?vue&type=script&lang=ts"
import style0 from "./addQuestionModal.vue?vue&type=style&index=0&id=01f06c29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f06c29",
  null
  
)

export default component.exports